import styled from "styled-components";

export const StyledMovementAtlasBetDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ul > li {
    position: relative;
    margin-bottom: 10px;
    border-bottom: 1px solid #cccccc;
    padding-bottom: 5px;
    .bet-odds {
      position: absolute;
      top: 0;
      right: 0;
      font-weight: bold;
    }

    .bet-event-name {
      font-weight: bold;
      color: #1234bb;
    }
  }
`;
